import type React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconExternalLink48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="external link">
            <path
                d="M31 2H44.5859L22.293 24.293L23.7072 25.7072L46 3.41437V17H48V0H31V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M3 4H22V6H3C2.44772 6 2 6.44772 2 7V45C2 45.5523 2.44772 46 3 46H41C41.5523 46 42 45.5523 42 45V25.8153H44V45C44 46.6569 42.6569 48 41 48H3C1.34315 48 0 46.6569 0 45V7C0 5.34315 1.34315 4 3 4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconExternalLink24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="external link">
            <path
                d="M15 2H20.5859L10.293 12.293L11.7072 13.7072L22 3.41436V9H24V0H15V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M0 4C0 2.89543 0.89543 2 2 2H11V4H2V22H20V13H22V22C22 23.1046 21.1046 24 20 24H2C0.895431 24 0 23.1046 0 22V4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconExternalLink16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="external link">
            <path
                d="M8 2H12.5859L4.29297 10.293L5.70718 11.7072L14 3.41436V8H16V0H8V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M0 4C0 2.89543 0.895431 2 2 2H6V4L2 4V14H12V10H14V14C14 15.1046 13.1046 16 12 16H2C0.89543 16 0 15.1046 0 14V4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
